import { Link } from "react-router";
import { Compass } from "lucide-react";
import { Button } from "../../components/ui/Button.js";
import { useAuth } from "../../lib/auth/index.js";
import { landingFor } from "../nav.js";

export function NotFound() {
  const { user } = useAuth();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <Compass aria-hidden className="size-7 text-mute" />
      <h1 className="font-display text-[24px] font-semibold tracking-tight">Esa ruta no existe</h1>
      <p className="max-w-[52ch] text-[13px] text-dim">
        No hay ninguna pantalla en esta dirección. Revisá el enlace o volvé al inicio.
      </p>
      <Link to={user ? landingFor(user.role) : "/login"}>
        <Button variant="primary">Volver</Button>
      </Link>
    </div>
  );
}

export default NotFound;
